// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7w-0";
export var startPickingButton = "_7w-1";